import { Button } from '@jouzen/ecom-components/v3/Button';
import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';

import { EventType } from '@/analytics/types';
import Image from '@/app/components/Image';
import RichText from '@/app/components/RichText';
import { LEGAL_FOOTNOTES_ID } from '@/app/consts/ids';

export const StoreNaturalCyclesSection = () => {
  const t = useTranslations();
  const handleClick = async (): Promise<void> => {
    await window.ouraAnalytics.track(EventType.CTAClicked, {
      cta: 'learn more',
      location: 'body',
      path: 'https://go.ouraring.com/naturalcycles',
      action: 'learn more nc',
    });
  };

  return (
    <div
      className="grid h-full w-full rounded-[40px] py-10 md:bg-transparent md:py-20"
      data-cy="natural-cycles-section"
    >
      <GridItem
        rowStart={{ sm: 1, md: 1 }}
        rowEnd={{ md: 2 }}
        colStart={{ sm: 1 }}
        className="relative h-25 overflow-hidden md:h-auto"
      >
        <Image
          src="store/bg-natural-cycles-filter"
          format="jpg"
          fill
          className="rounded-t-[40px] object-cover md:rounded-[40px]"
          sizes="100vw"
          alt="integrations_natural_cycles_card_img_alt"
        />
      </GridItem>
      <GridItem
        rowStart={{ sm: 2, md: 1 }}
        rowEnd={{ sm: 3, md: 2 }}
        colStart={{ sm: 1 }}
        className="z-10 flex flex-col gap-10 rounded-b-[40px] bg-sandstone-500 px-6 py-10 text-sandstone-100 md:bg-transparent md:px-15 md:py-15 lg:px-30 lg:py-15"
      >
        <Typography
          className="flex max-w-none flex-row text-heading-base text-sandstone-100 md:max-w-4/5 md:text-heading-xl xl:max-w-2/3"
          data-cy="nc-title"
          Element="h2"
        >
          {t('try_nc_for_free')}
        </Typography>
        <div
          className="gap-5 md:grid md:grid-cols-3 lg:grid-cols-2"
          data-cy="nc-subcopy"
        >
          <div className="gap-0 md:col-span-2 lg:col-span-1 lg:gap-2">
            <Typography
              className="text-heading-xs text-sandstone-100 lg:text-heading-sm"
              data-cy="nc-subcopy-title"
              Element="h3"
            >
              {t('powered_by_oura')}
            </Typography>
            <div className="flex flex-col gap-5" data-cy="nc-subcopy-content">
              <Typography
                className="text-base text-gray-300"
                color="unset"
                data-cy="nc-subcopy-1"
              >
                {t('oura_nc_free_subcopy_1')}
              </Typography>
              <Typography
                className="text-base text-gray-300"
                color="unset"
                data-cy="nc-subcopy-2"
              >
                <RichText
                  messageKey="oura_nc_free_subcopy_2"
                  tValues={{
                    footnoteLink: () => (
                      <sup>
                        <a href={`#${LEGAL_FOOTNOTES_ID}`}>**</a>
                      </sup>
                    ),
                  }}
                />
              </Typography>
            </div>
          </div>
        </div>
        <div className="flex">
          <Button
            variant="outlined-light"
            href="https://go.ouraring.com/naturalcycles"
            target="_blank"
            onClick={() => handleClick()}
          >
            {t('learn_more')}
          </Button>
        </div>
      </GridItem>
    </div>
  );
};
